export const costs = [
  'Sleepless nights searching for ways to translate complex forensic science concepts into language your students can understand.',
  "Improvised classes because you couldn't find clear, ready-to-use materials in time.",
  "Disconnected students who don't see how forensic science connects to their futures, careers, or real-world investigations.",
  "Awkward silences when a student asks about evidence analysis or how to interpret findings and you don't have a clear answer.",
  'Weekends lost building lesson plans, forensic science projects, and assessments from scratch over and over.',
  'Uncertainty about how to teach forensic evidence, DNA analysis, critical thinking, ethical responsibility, or evidence interpretation without adequate resources.',
];
